import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //引入element语言包
import zhCN from "vxe-table/lib/locale/lang/zh-CN";
const zh = {
  message: {
    button: {
      generateItemNumber: "生成物料编码",
      upgradeRevchangeMfrGenNumber: "升级版本/变更供应商生成编码",
      generateCodeNumber: "生成编号",
      upgradeSequence: "升级序列号",
      upgradeRev: "升级版本号",
      changeManufacture: "变更制造商",
      save: "保存",
      delete: "删除",
      deleteForm: "删除该表",
      Undo: "还原",
      cancel: "取消",
      clearSelected: "取消选中",
      replace: "替换",
      clear: "清空",
      add: "添加",
      edit: "编辑",
      affirm: "确定",
      import: "导入",
      download: "下载",
      preview: "预览",
      export: "导出",
      exportAll: "全部导出",
      importRemak: "计划备注导入",
      creat: "新建",
      actions: "操作",
      comment: "备注",
      details: "详情",
      reset: "重置",
      create: "新建",
      createNow: "立即创建",
      search: "搜索",
      simpleSearch: "简单搜索",
      advancedSearch: "高级搜索",
      bookmark: "收藏",
      cancelBookmark: "取消收藏",
      pause: "暂停",
      cancelPause: "取消暂停",
      cancel: "取消",
      createChange: "创建变更",
      createItemQuality: "创建质量单",
      release: "更新",
      submit: "提交",
      next: "下一步",
      exportModel: "导出模板",
      done: "完成",
      toImport: "上  传",
      check: "查看",
      order: "排序",

      confirmSetting: "确认设置",
      saveAs: "另存为",
      return: "返回",
      calculateScore: "计算得分",
      effect: "生效",
      invalid: "反生效",
      projectStatus: "项目状态",
      cancelCode: "取消编码",
      BOMshow: "仅展示第一层BOM",
      ProductDataQuery: "产品数据报表",
      taskstatement: "任务查询报表",
      executorstatement: "执行进度报表",
      remark: "计划备注报表",
      testLink: "测试连接",
      downloadAttachment: "交付件下载",
      list: "列表",
      state: "状态",
      type: "类型",
      members: "成员",
      copyBOM: "复制BOM",
      stcokQuery: "库存查询",
      gantt: "甘特图",
      TreeView: "树形查看",
      createCAPA: "创建CAPA",
      previousPage: "上一页",
      nextPage: "下一页",
      dataMapping: "数据映射",
      fill: "填充",
      expandAll: "一键展开",
      startDate: "开始时间",
      endDate: "结束时间",
      selectUser: "搜索用户",
      selectRange: "搜索范围",
      payload: "工作负载度",

      assignRoles: "分配角色",
      removenRoles: "分配角色",
      authorize: "授权",
      authShift: "授权转移",

      print: "打印",
      copy: "拷贝受影响物件",
      paste: "粘贴",
      upFill: "向上填充",
      downFill: "向下填充",
      expand: "展开",
      close: "收起",

      MatchAttachment: "附件匹配",

      RegenerateXML: "重新生成XML文件",
      exportExcel: "Excel 导出",
      restoreChange: "变更状态回退",

      closeProject: "关闭",
    },
    title: {
      globalSearch: "全局搜索",
      personalSearch: "个人搜索",
      noPendingItem: "过滤未完成变更物料",
      readAndAgree: "我已仔细阅读并同意",
      addApprover: "审阅者",
      addObserver: "观察者",
      annotation: "注解",
      userLogin: "账号登录",
      login: "登录",

      OverallStatus: "全体状态",
      ScheduleStatus: "计划状态",
      CostStatus: "成本状态",
      ResourceStatus: "资源状态",

      emptyText: "暂无数据",
      emptyTextInAttachment:
        "请将文件/文件夹拖动到表格处上传或通过点击添加按钮上传",
      allFilter: "全部",
      initial: "初始",

      welcome: "欢迎进入系统",
      releaseFlow: "发布流程一览",
      workflow: "工作流",
      addForStatus: "添加状态",
      editAP_OB: "编辑审察者",
      addAP_OB: "添加审阅者和观察者",
      searchUser: "查找用户",
      addStatus: "添加状态",
      approver: "审察者",
      observer: "观察者",
      comments: "注解",
      workflowExport: "工作流导出.xlsx",
      BOMdoc: "BOM导出.xlsx",
      importRelationshipTemplate: "关联对象导入模板.xlsx",
      importMfrpTemplate: "物料制造商部件导入模板.xlsx",

      manualNextStatus: "下一状态",

      check: "审核",
      approveRelease: "批准",
      approve: "批准",
      rejectRelease: "拒绝",
      reject: "拒绝",
      finish: "完成",
      fileName: "文件名",
      importDate: "上传时间",

      aboutUs: "关于我们",
      studyOnline: "在线学习",
      serviceOnline: "在线客服",
      changePW: "修改密码",
      logout: "退出登录",
      userSetting: "个人设定",
      viewTool: "3D工具",

      search: "搜索",
      quickSearch: "快速搜索",
      advancedSearch: "高级搜索",
      searchCriteria: "搜索条件",
      searchResult: "搜索结果",
      totalResults: "共搜索到:",
      resultsNums: "条数据",
      missingRows: "不显示没有权限的结果.",
      searchUnit: "条结果",

      importFile: "对象导入",
      importBOM: "BOM导入",
      importRelationship: "导入关联对象",
      importMfrp: "导入制造商部件",
      fileModel: "文件模板",
      fileImport: "文件上传",
      isGenerateCodeNumber: "是否生成编号",
      isPreemptive: "抢占模式",
      importgeneralBOM: "通用BOM导入",
      ImportPlanRemarks: "项目计划备注导入",
      projectSchedule: "项目进度预览",
      projectScheduleReports: "项目进度报表",

      // myProject:'项目看板',
      myProcess: "我的流程",
      myDashboard: "仪表板",
      myProject: "项目看板",
      myAgent: "任务看板",

      componentLibrary: "器件库",

      myPriority: "我的待办",
      myTracing: "我的追踪",
      mySubmit: "我的提交",
      myNotice: "我的通知",
      changeNotice: "变更通知",
      setting: "个人设定",
      priorityChange: "待处理变更",
      participationChange: "参与的变更",
      submittedChange: "已提交变更",
      cover: "封面",
      affectedModel: "受影响的物件",
      workflow: "工作流",
      summary: "一览 (BOM发布流程)",
      history: "历史记录",

      approve: "批准",
      reject: "拒绝",
      add: "添加",

      currentVolume: "当前数据量",
      dilation: "扩容",

      BatchImportDoc: "图纸/文档批量导入",

      createFolder: "请创建对应文件夹",
      saveNode: "保存节点",

      rev: "版本",

      create: "新建",
      changeObject: "受影响的物件",
      createModel: "物料创建",
      createChange: "变更创建",
      createManufacturer: "制造商创建",
      createManufacturerPart: "制造商部件创建",
      quickCreate: "快速创建",

      createList: "列表创建",
      baseInfo: "基本信息",
      listVal: "列表值",
      listWhereUsed: "使用位置",
      createWorkflow: "工作流创建",
      createprojectWorkflow: "项目审批流程创建",

      autoNumber: "编号自动生成",
      autoNumber2: "自动编号",
      userGroup: "用户组",

      pageOne: "第一页",
      pageTwo: "第二页",
      pageThree: "第三页",

      relationship: "关联对象",
      manufacturer: "制造商",
      attachment: "附件",
      itemAttachment: "物件的附件",
      titleBlock: "详细信息",

      list: "列表",
      preferences: "首选项",
      whereUsed: "使用位置",
      PGWhereUsed: "等待变更使用位置",
      pendingChange: "等待变更",
      releasedChange: "发布变更",
      deliverables: "交付件",

      addRole: "添加角色",
      editRole: "编辑角色",
      saveAs: "另存为",
      editPrivilege: "编辑权限",
      addPrivilege: "添加权限",
      changeStatusTo: "将状态变更为",
      emailSetting: "邮箱设置",
      IntegrationSetting: "集成设置",
      EmailServiceSettings: "邮箱服务配置",
      preference: "首选项设置",
      emailHost: "邮箱服务器",
      emailPost: "端口号",
      emailUser: "邮箱账号",
      emailPassWord: "邮箱密码",
      IntegrationHost: "集成服务器",
      IntegrationPost: "端口号",
      IntegrationUser: "集成用户账号",
      IntegrationPassWord: "集成用户密码",
      selectTemplate: "选择模板",
      resourceMapping: "资源映射",
      code: "编码",
      codeInstructions: "规则名称",
      des: "描述",
      codeObject: "选择编码对象",
      defineCodePro: "定义编码属性",
      proNormalState: "正常状态",
      prosuspended: "已暂停",
      proShutDown: "已关闭",
      tasknormal: "任务正常",
      taskOverdue: "将要逾期",
      taskDelay: "超过预期",
      taskSuspended: "暂停阶段",
      taskClose: "关闭阶段",
      rootName: "所属项目",
      firstLayerProjectName: "所属一级任务",
      parentName: "所属上级任务",
      proName: "项目名称",
      type: "类型",
      startTime: "	起始时间",
      endTime: "终止时间",
      createTime: "创建时间",
      overdueDays: "逾期天数",
      principal: "负责人",
      redLine: "划红线",

      BOMCompare: "BOM报表对比",
      PurchaseList: "采购清单",
      BOMGather: "BOM 汇总",

      priority: "待办",
      inProcess: "进程中",
      completed: "已完成",

      universal: "通用",
      uploadLogo: "logo上传",
      uploadPictures: "点击上传图片",

      ConditionalSearch: "条件搜索",

      Checked: "已选中",
      className: "分类名",
      searchName: "搜索名称",
      searchSave: "搜索保存",
      searchType: "搜索类型",

      AppId: "应用号",
      CorpId: "企业号",
      CorpSecret: "密钥",

      authorize: "授权",
      folder: "文件夹",
      inheritBOM: "是否继承BOM",

      allFields: "全部",
      payload: "工作负载度",
      startDate: "开始时间",
      endDate: "结束时间",
      replacedResources: " 被替换的资源",
      replaced: "替换为",
      WeCom: "企业微信",
      Dingding: "钉钉",
      CreateNewScheduledTasks: "新建定时任务",
    },
    placeholder: {
      companyName: "公司名",
      userName: "用户名",
      PW: "密码",
      search: "请输入",
      input: "请输入",
      select: "请选择",
      pickDate: "请选择日期时间",
      startDate: "开始时间",
      endDate: "结束时间",
      selectAttribute: "请选择属性",
      selectOperator: "请选择运算符",
      project: "项目",
      state: "状态",
      stateType: "状态类型",
      lateType: "逾期类型",
      keyword: "关键字",

      //定时任务
      PleaseEnterTheTaskName: "请输入任务名称",
      PleaseEnterTaskDescription: "请输入任务描述",
      PleaseSelectExecutionCycle: "请选择执行周期",
      PleaseSelectExecutionWeek: "请选择执行星期",
      PleaseSelectTime: "请选择时间",
      PleaseChooseNotificationMethod: "请选择通知方式",
      PleaseChooseEnableOption: "请选择是否启用",
      PleaseEnterTheRecipientEmailAddress: "请输入收件人邮箱",
      PleaseEnterTheCCRecipientEmailAddress: "请输入抄送人邮箱",
    },
    success: {
      upLoad: "上传成功",
      downLoad: "下载成功",
      save: "保存成功",
      changePW: "修改密码成功",
      delete: "删除成功",
      addFavoriteSuccessfully: "添加收藏成功",
      removeFavoriteSuccessfully: "取消收藏成功",
      actions: "操作成功",
    },
    error: {
      workflowNotNull: "工作流不能为空",
      commonServerError: "出现错误，请联系管理员。",
      pickBaseClass: "请选择类型。",
      cantModify: "已被使用，不能修改。",
      cantDelete: "已被使用，不能删除。",
      rejectNoComments: "请填写拒绝原因。",
      change: "修改失败",
      notSame: "两次输入不一致",
      nameRepeat: "名称不可重复",
      save: "保存失败",
      name: "名称不可为空",
      performanceNum: "表单编号不可为空",
      rejectToStatus: "请设置拒绝返回状态",
      invalidedrejectToStatus: "拒绝返回状态不在下一状态中。",
      type: "类型不可为空",
      input: "输入内容为空",
      search: "查询失败",
      pending: "待定状态不能被删除",
      noChange: "没有值改动，不用保存。",
      pendding: "Pendding 状态不可被删除",
      addSame: "添加失败: 无法添加重复用户",
      sameUser: "请不要重复添加相同用户",
      same: "请不要重复添加制作商部件",
      add: "添加失败",
      delete: "删除失败",
      assginRoles: "分配角色失败",
      privilegeAdd: "权限添加失败,",
      privilegeLoad: "权限加载失败,",
      privilegeUser: "添加失败,该用户权限不足",
      roleRefrash: "角色信息更新失败",
      roleAdd: "角色添加失败",
      roleEdit: "角色编辑失败",
      noEdit: "禁止编辑",
      deleteData: "选择的数据中无法被删除，请重新选择",
      unDoData: "选择的数据中无法被还原，请重新选择",
      loadAP_OB: "装载审批者观察者失败",
      approve: "批准失败",
      reject: "拒绝失败",
      param: "参数格式不正确",
      emailHost: "邮箱服务器不能为空",
      emailAccounts: "请输入邮箱地址",
      emailAddress: "请输入正确的邮箱地址",
      emailPassWord: "密码不能为空",
      IntegrationHost: "集成服务器不能为空",
      IntegrationAccounts: "请输入集成系统账号",
      // IntegrationAddress: '请输入正确的邮箱地址',
      IntegrationPassWord: "密码不能为空",
      post: "端口号不能为空且为数字",
      nameUsed: "该名称已被使用",
      autoNumLength: "起始数字长度应小于数字长度，请重新编辑",
      autoNumLengthLessTen: "数字长度不得超过9",
      disabledUser: "该用户已被禁用",
      pleaseDisable: "是否启用请改为“否”",
      userMustOne: "流程已经执行，执行者必须有一位",
      onlyOneOrTwo: "只可选择1条或2条数据进行对比",
      codeValueLength: "请填写编号长度",

      selectOneExecutor: "请选择被替换的执行者",
      onlyOneExecutor: "只能选择一位执行者",
    },
    tips: {
      alreadyLastPage: "已经到达最后一页",
      alreadyFirstPage: "已经到达最上页",
      intervalTooShort: "查询间隔过短",
      notFind: "没有找到",
      searching: "搜索中",
      upLoad: "窗口请勿关闭！文件正在上传，请耐心等待",
      closeUpLoad: "是否进行后台上传？",
      downLoad: "窗口请勿关闭！文件正在下载，请耐心等待",
      noData: "暂无数据",
      terms: "请仔细阅读并同意《杰信云隐私政策》, 《杰信云用户协议》",
      dataEnd: "数据已经到底了!",
      dele_data: "请选择需要删除的数据",
      companyName: "请输入公司名称",
      userName: "请输入用户名",
      PW: "请输入密码",

      tip: "提示",
      name: "请输入名称",
      saveCancel: "已取消保存",
      deleteCancel: "已取消删除",
      cancel: "已取消",
      closeSucess: "关闭成功",
      tab: "页面至少存在一条TAB页",
      exportModel: "点击查看“对象导入”操作手册",
      exportBom: "点击查看“BOM导入”操作手册",
      importRelationshipGuide: "点击查看“关联对象导入”参考文档",
      importMfrpGuide: "点击查看“制造商部件导入”参考文档",

      noData: "暂无数据",
      quickCreateTips:
        "请先输入要创建 部件 的关键字，并点击新建,新建后填写必填属性。",

      createNewData: "当前类型下没有产品数据，请新建",

      // Copyright: "版权所有 ©杰信软件(苏州)科技有限公司 苏ICP备16064918号-2",
      Copyright: "版权所有© 无锡杰信软件科技有限公司 苏ICP备2025179810号-1 ",
      ClearCache: "清空本地缓存",

      inputName: "请输入名称",
      inputDes: "请输入描述信息",

      changePW: "密码修改成功，点击确定重新登录",
      reLogin: "请重新登录",

      workflow_101:
        "存在下列问题,必须先解决所有Errors, 编辑完成后需要保存，才能进入下一状态;",
      workflow_102: "如果只存在Warnings, 不影响进入下一状态",
      workflow_103:
        "选择向之通知状态变更的用户。如果下一状态为审批状态，请选择审阅者",

      e_202: "权限不足，无法查看本条数据",

      e_203: "保存失败！审批者与观察者不能含有相同用户。",
      e_204: "保存失败！数据未修改",

      m_301: "编号由系统自动生成",
      m_302: "此操作将删除该类（使用中则无法删除）, 是否继续?",
      inLinkage: "联动中",
      hasSameItem: "已存在以下描述相同的物料，是否继续创建?",

      changeSubClass: "改变类型可能会导致部分数据不能完全复制",
      requiredError: " 必填项不能为空,以下必填项为空",
      duplicateObject: "已存在以下描述相同的物料，是否继续创建?",

      selcetParentProject: "请选择父项目",
      saveCurrentRow: "请先保存当前行",
      del_01: "请到父级计划页下删除本任务",
      add_01: "关卡/里程碑 下不可添加子任务,",
      add_02: "当前任务下不可以只有关卡/里程碑",
      add_03: "该项目/任务已完成，不可添加子任务",

      date_01: "计划开始日期不得晚于计划结束日期",
      date_02: "当前状态下，计划开始日期不得晚于任务的计划开始日期",
      date_03: "当前状态下，计划开始日期不得早于父任务开始日期",
      date_04: "计划结束日期不得早于计划开始日期",
      date_05: "当前状态下，计划结束日期不得早于子任务的计划结束日期",
      date_06: "当前状态下，计划结束日期不得晚于父项计划结束日期",

      item_mfc_tips: "首选状态替代项不可重复",
    },
    confirm: {
      modifyCodeAttributes: "升级序列号/版本号操作，是否确认修改编码字段?",
      deleteSearch: "您确定要删除此个人搜索?",
      deleteData: "您确定要删除该数据?",
      taskDeleteData: "任务正在进行状态，是否要删除，如果删除，父任务状态不变",
      deleteFormList: "您确定要删除该条报表?",
      cancelData: "您确定要关闭该项目?",
      unDoData: "您确定要还原该数据?",
      deleteList: "是否删除该条列表?",
      deleteObject: "此操作将删除该对象, 是否继续?",
      clearSchedule: "此操作将清空该项目, 是否继续?",
      closeAllTabs: "是否关闭当前页以外所有的页签?",
      logout: "此操作将退出系统, 是否继续?",
      close: "确认关闭？",
      overwrite: "该文件已经存在，是否覆盖？",
      closeWithoutSave: "当前页面有未保存信息，确定离开么",
    },
    Auth: {
      authShift: "授权转移",
      isAuth: "是否启用",
      authUser: "授权用户",
      scope: "授权范围",
    },
    table: {
      mouserSN: "Mouser字段",
      mourserValue: "Mouser字段值",
      plmSN: "PLM字段",
      manufacturer: "制作商",
      address: "地址",
      name: "名称",
      userName: "用户名",
      userID: "用户ID",
      user: "用户",
      fileResources: "文件资源",
      sysUser: "系统用户",
      group: "组",
      roleName: "角色名称",
      projectName: "名称",
      baseInfo: "基本信息",
      mark: "用户界面标签",
      lifecyclephases: "生命周期阶段",
      newSub: "新建子类分类",
      des: "描述",
      status: "状态",
      type: "类型",
      displayType: "显示类型",
      listType: "列表类型值",
      codeValueLength: "编号长度",
      statusValue: "状态值",
      actions: "操作",
      privilege: "权限名",
      privilegeType: "权限类型",
      criteria: "标准",
      classify: "分类",
      dataType: "数据分类",
      workflow: "工作流",
      startStatus: "开始状态",
      endStatus: "结束状态",
      applied: "应用于",
      createDate: "创建时间",
      country: "国家",
      city: "城市",
      isEnabled: "是否启用",
      statusVal_01: "不可用",
      statusVal_02: "可用",

      number_: "编号",
      changeDes: "变更描述",
      changeStatus: "变更状态",
      // workflow:''

      numberLength: "数字长度",
      startNumber: "起始数字",
      prefix: "前缀",
      suffix: "后缀",
      nextAutoNumber: "下一个编号",

      enabled: "活动",
      disabled: "非活动",

      enabled_01: "启用",
      disabled_01: "禁用",

      simple: "普通",
      cascade: "瀑布",
      dynamic: "动态",
      code: "编号",
      serialNumber: "序列号",
      versionNumber: "版本号",
      reference: "引用",
      SN: "序号",

      listOrder: "列表拖动排序",
      list: "列表",
      search: "查询",
      required: "必填",
      visible: "可视",

      nextStatus: "下一状态",
      entryReq: "进入所需字段",
      exitReq: "退出所需字段",
      ifReject: "若拒绝，请设置状态",
      approver: "审阅者",
      observer: "观察者",

      yes: "是",
      no: "否",
      none: "无",
      selectStartOrEnd: "请选择开始时间/结束时间",
      templateName: "模板名称",
      copyRelate: "是否拷贝相关人员",
      currency: "人民币",

      relatedOldDoc: "关联旧图号",

      order: "排序",
      property: "属性",
      class: "类",
      tab: "页签",

      PW: "密码",
      oldPW: "旧密码",
      PWagain: "重复密码",
      newPW: "新密码",
      newPWagain: "重复密码",
      PWnotSame: "密码输入不一致",

      pageThree: "第三页",
      title: "标题块:",

      text: "文本框",
      textarea: "多行文本框",
      selectList: "下拉菜单",
      multilist: "多选下拉菜单",
      date: "日期",
      number: "数字",
      richText: "富文本",
      money: "货币",
      defaultValue: "默认值",
      placeholder: "换行占位符",

      weightOfKey: "重点项目权重",
      weightOfNonKey: "非重点项目权重",
      autoVersion: "版本自动生成",
      isVerify: "实际工时校验",
      exportChange: "导出发布变更",
      cancelAll: "取消所有",
      more: "更多",
      all: "所有",

      onlineNumbers: "在线人数",
      allPerpon: "所有人",
      linkage: "联动",

      rejected: "被拒绝",
      submitDate: "提交时间",
      createdDate: "创建时间",
      completedDate: "完成时间",

      //定时任务字段
      taskName: "任务名称",
      taskDescription: "任务描述",
      taskStatus: "任务状态",
      executeCycle: "执行周期",
      executionWeek: "执行星期",
      executeTime: "执行时间",
      notificationMethod: "通知方式",
      recipient: "收件人",
      cc: "抄送人",
    },
    warning: {
      alreadyInPersonalSearch: "名称已存在",
      alreadyInFavorite: "已收藏",
      searchErr_01: "查询条件不能为空",
      searchErr_02: "搜索结果为空，请重新搜索",
      blankRequired: "必填项不能为空",
      substituteTissueRelNotOneBlank: "请检查替代关系和替代组的值。",

      length_101: "长度在 3 到 25 个字符",
      length_102: "长度在 5 到 20 个字符",
      length_103: "长度在 1 到 200 个字符",
      length_104: "长度在 5 到 15 个字符",
      length_105: "长度在 1 到 18 个字符",
      length_106: "长度在 3 到 18 个字符",
      length_107: "长度在 3 到 40 个字符",
      length_108: "长度在 5 到 40 个字符",

      nameRequired: "名称必须填写",
      inputPW: "请输入密码",
      required: "必填项不能为空",

      privilege: "请输入权限名称",
      choice: "请单独选择一个附件",
      name: "名称不能为空",
      PW: "密码不能为空",
      PWLength: "长度在 6 到 30 个字符",
      confirmPW: "密码不能为空",
    },
    workflowType: {
      Pending: "待定",
      Submit: "提交",
      Review: "审批",
      Released: "发布",
      Complete: "结束",
      Cancel: "取消",
      Hold: "暂停",
    },
    ppmWorkflowType: {
      Pending: "待办",
      Progress: "进行中",
      Complete: "已完成",
      Reject: "已拒绝",
      w_101: "Please select workflow first",
    },

    transform: {
      choices: "待选项",
      selected: "已选择",
      assignRoles: "分配角色",

      w_101: "请先选择工作流",
    },

    list: {
      baseInfo: "基本信息",
      pageOne: "第一页",
      pageTwo: "第二页",
      pageThree: "第三页",
      pendingChange: "等待变更",
      pendingChangeWhereUsed: "等待变更使用位置",
      changeHistory: "变更历史记录",
      BOM: "BOM",
      manufacturer: "制造商",
      attachment: "附件",
      itemAttachment: "物件的附件",
      whereUsed: "使用位置",
      relationship: "关联对象",
      historyRecord: "历史记录",
      affectedObjects: "变更对象",
      preferences: "首选项",
      userGroup: "用户组",
      user: "用户",
      schedule: "计划",
      deliverables: "交付件",
      team: "执行者",
      scheduleComments: "计划备注",
      scheduleCommentsTemplate: "计划备注模板",
      questionObject: "问题对象",
      associateTheSameForm: "关联相同表单",
      showAttribute: "字段展示",
      showAttributeName: "显示字段名称",
      itemQuality: "质量单",

      duplicateType: "该类型已存在",

      Separator: "分隔符",
      relatedItem: "关联物料",
      relatedResource: "关联资源/资源组",
      owningTechnology: "所属工艺路线",
      owningResource: "所属资源",
      itemRelatedTechnology: "工艺信息",
    },
    operatorGroup: {
      IsNull: "为空",
      IsNotNull: "不为空",
      EqualTo: "等于",
      NotEqualTo: "不等于",
      Like: "类似",
      NotLike: "不类似",
      Contains: "包含",
      DoesNotContains: "不包含",
      StartsWith: "开始于",
      DoesNotStartsWith: "不开始于",
      Between: "在",
      NotBetween: "不在",
      Between_DM: "在",
      NotBetween_DM: "不在",
      ContainsAny: "包含任何",
      ContainsAll: "包含全部",
      ContainsNone: "不包含任何",
      GreatThan: "大于",
      GreatThanOrEqualTo: "大于等于",
      LessThan: "小于",
      LessThanOrEqualTo: "小于等于",

      and: "和",
      or: "或",
    },
    performance: {
      firstTitle: "个人绩效考核主表",
      secondTitle: "项目绩效执行情况(子表)",
      scoreData: "项目绩效打分",
      otherScoreData: "非项目绩效打分",
      HrScoreData: "部门及HR考核打分",
      formNumber: "表单编号：",
      formName: "表单名称：",
      jobNumber: "工号：",
      name: "姓名：",
      Department: "所属部门：",
      assessmentDate: "考核日期：",
      documentDate: "单据日期：",
      preparer: "制单人：",
      keyProjects: "重点任务打分：",
      noKeyProjects: "非重点任务打分：",
      assessor: "打分人：",
      otherAssessment: "其他考核：",
      performanceScoreData: "工作日志打分：",
      performanceHrScoreData: "5S打分:",
      description: "说明：",
      performanceScore: "综合绩效考核得分：",
      keyProject: "是否为重点项目：",
      projectManager: "执行人：",
    },
    agent: {
      principal: "负责人",
      projectManager: "项目领导",
      observer: "观察者",
      executors: "执行者",
    },
    titleBlockImg: {
      bigImg: "图片最大可支持上传 4MB,请重新上传！",
      notImg: "仅支持图片格式文件(jpg,jpeg,gif,png,bmp),请重新上传！",
    },
    calendar: {
      currentYear: "当前年份",
      year: "年",
      month: "月",
      day: "日",
      week: "周",
      season: "季",
    },
  },

  ...zhLocale,
  ...zhCN,
};

export default zh;
